<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto transition ease-in-out outline-none backdrop bg-overlay focus:outline-none">
        <div class="p-6 mb-8 bg-white rounded shadow-md lg:ml-8">
            <div class="flex items-start justify-between mb-6">
                <div class="p-2 rounded-full bg-muted">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <button class="border border-transparent focus:border-blue trans-all-linear" type="button" @click="$emit('toggleAcceptModal', showModal)">
                    <svg class="w-8 h-8 text-grey hover:text-grey-dark" width="32" height="32" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
                    </svg>
                </button>
            </div>
            <div class="mb-3 leading-normal">
                <h1 class="mb-2 text-base font-bold">{{ title }}</h1>
                <p class="mb-6 text-sm font-semibold text-grey-darker">{{ msg }}</p>
            </div>
            <footer class="flex justify-end align-center">
                <button @click="$emit('toggleAcceptModal', showModal)" class="p-3 mr-3 text-sm font-semibold border-2 border-grey-light focus:bg-grey-light focus:border-blue trans-all-linear" type="button">Cancel</button>
                <slot></slot>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminAcceptModal",
    props: {
        title: String,
        msg: String,
    },
    data()
    {
        return {
            showModal: true
        }
    },
    methods:
    {
        showReviewAcceptModal()
        {
            this.showAcceptModal = true;
        },
        hideReviewAcceptModal()
        {
            this.showAcceptModal = false;
        }
    }
}
</script>
